/**
 * Cross-platform browser auto-open utility.
 *
 * Opens a file in the user's default browser.
 * Fire-and-forget — never throws, errors logged to stderr.
 */

import { exec } from 'node:child_process';

export function openInBrowser(filePath: string): void {
  try {
    const platform = process.platform;
    let command: string;

    if (platform === 'darwin') {
      command = `open "${filePath}"`;
    } else if (platform === 'win32') {
      command = `start "" "${filePath}"`;
    } else {
      command = `xdg-open "${filePath}"`;
    }

    exec(command, (err) => {
      if (err) {
        process.stderr.write(
          `[testrelic] Failed to open browser: ${err.message}\n`,
        );
      }
    });
  } catch {
    // Never crash the reporter
  }
}
